var _rect, _line, _line2, _line3, _line4, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRadiology(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 36,
    height: 36,
    rx: 4,
    stroke: "#0077B6",
    strokeWidth: 3
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 14,
    x2: 22,
    y2: 34,
    stroke: "#0077B6",
    strokeWidth: 2.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 26,
    y1: 14,
    x2: 26,
    y2: 34,
    stroke: "#0077B6",
    strokeWidth: 2.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 22,
    x2: 34,
    y2: 22,
    stroke: "#0077B6",
    strokeWidth: 2.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 26,
    x2: 34,
    y2: 26,
    stroke: "#0077B6",
    strokeWidth: 2.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 3,
    fill: "#F38E1A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadiology);
export default __webpack_public_path__ + "static/media/radiology.563e427d40469751494403c6d25f9c46.svg";
export { ForwardRef as ReactComponent };